import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';

const Bills = () => {
    const [title, setTitle] = useState("Agregar Gasto por Unidad");
    const [loading, setLoading] = useState(false);
    const [bills, setBills] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [partners, setPartners] = useState([]);
    const [units, setUnits] = useState([]);
    const [bill_id, setBillId] = useState(0);
    const [date, setDate] = useState(new Date());
    const [price, setPrice] = useState(0);
    const [concept, setConcept] = useState('');
    const [partner_id, setPartnerId] = useState(0);
    const [driver_id, setDriverId] = useState(0);
    const [unit_id, setUnitId] = useState(0);
    const [gasoline, setGasoline] = useState(0);
    const [meal, setMeal] = useState(0);
    const [salary, setSalary] = useState(0);
    const [spare_parts, setSpareParts] = useState(0);
    const [negatives, setNegatives] = useState(0);
    const [personal, setPersonal] = useState(0);
    const [permissions_documents, setPermissionsDocuments] = useState(0);
    const [schedule_id, setScheduleId] = useState(0);
    const [running_date, setRunningDate] = useState('');
    const [mileage, setMileage] = useState(0);
    const [stand, setStand] = useState(0);
    const [administrative, setAdministrative] = useState(0);
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [status_filter, setStatusFilter] = useState(2);
    const [driver_filter, setDriverFilter] = useState(0);
    const [partner_filter, setPartnerFilter] = useState(0);
    const [unit_filter, setUnitFilter] = useState(0);
    const [date_filter, setDateFilter] = useState(''); // Nuevo estado para fecha
    const [selectedUserId, setSelectedUserId] = useState(0);
    const [users, setUsers] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT; 

    useEffect(() => {
        getAll();
        getDrivers();
        getPartners();
        getUnits();
        setTimeout(() => {
            initializeSelect2();
        }, 100);
        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    

    useEffect(() => {
        // Convert all values to numbers and handle NaN cases
        const gasolineVal = Number(gasoline) || 0;
        const mealVal = Number(meal) || 0;
        const salaryVal = Number(salary) || 0;
        const sparePartsVal = Number(spare_parts) || 0;
        const negativesVal = Number(negatives) || 0;
        const personalVal = Number(personal) || 0;
        const permissionsDocumentsVal = Number(permissions_documents) || 0;
        const mileageVal = Number(mileage) || 0;
        const standVal = Number(stand) || 0;

        const user = JSON.parse(localStorage.getItem('dataUser'));
    if (user && user.user_id === 13) {
        fetchUsers();
    }
        // Calculate total
        const total = gasolineVal + mealVal + salaryVal + sparePartsVal + negativesVal + personalVal + permissionsDocumentsVal + mileageVal + standVal;
        // Update price state
        setPrice(total);
    }, [gasoline, meal, salary, spare_parts, negatives, personal, permissions_documents, mileage, stand]);

    const initializeSelect2 = () => {
        $('#partner_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#driver_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#unit_id').select2({ width: "100%", dropdownParent: $('#modal-default') });
        $('#status_filter').select2({ width: "100%" });
        $('#partner_filter').select2({ width: "100%" });
        $('#unit_filter').select2({ width: "100%" });
        $('#driver_filter').select2({ width: "100%" });
    };

    const fetchUsers = async () => {
    try {
        const response = await axios.get(ENDPOINT + "get-all-users");
        setUsers(response.data.data);
    } catch (error) {
        console.error("Error fetching users:", error);
    }
};

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activo', value: 1 },
        { label: 'Inactivo', value: 0 }
    ];

    $('#partner_filter').on("change", function (e) {
        setPartnerFilter(e.target.value);
    });
    
    $('#driver_filter').on("change", function (e) {
        setDriverFilter(e.target.value);
    });

    $('#unit_filter').on("change", function (e) {
        setUnitFilter(e.target.value);
    });

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    $('#partner_id').on("change", function (e) {
        setPartnerId(e.target.value);
    });
    
    $('#driver_id').on("change", function (e) {
        setDriverId(e.target.value);
    });

    $('#unit_id').on("change", function (e) {
        setUnitId(e.target.value);
    });

    const getDrivers = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-drivers-bills');
        const driversArray = response.data.data.map(function (element) {
            return {
                label: element.name + ' ' + element.last_name,
                value: element.driver_id,
            };
        })
        setDrivers(driversArray);
    };

    const getPartners = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-partners-bills');
        const partnersArray = response.data.data.map(function (element) {
            return {
                label: element.name_partner,
                value: element.partner_id,
            };
        })
        setPartners(partnersArray);
    };

    const getUnits = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-units-bills');
        const unitsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.unit_id,
            };  
        })  
        setUnits(unitsArray);
    };

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        const form = new FormData();
        form.append("status_filter", status_filter);
        form.append("driver_filter", driver_filter);
        form.append("partner_filter", partner_filter);
        form.append("unit_filter", unit_filter);
        form.append("date_filter", date_filter); // Agregar fecha al form
        await axios.post(ENDPOINT + 'get-all-bills', form).then((response) => {
            setBills(response.data.data);
            setActive(response.data.data.filter((e) => e.status === 1).length);
            setInactive(response.data.data.filter((e) => e.status === 0).length);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: false,
                    autoWidth: false,
                    paging: true,
                    ordering: false,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar",
                    },
                });
                setLoading(false);
            }, 100);
        })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    };

    const handleNew = () => {
        clearField();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        // Si el usuario especial está en sesión y NO se seleccionó usuario, usa el de sesión
        let user_id;
        if (user && user.user_id === 13) {
            user_id = selectedUserId > 0 ? selectedUserId : user.user_id;
        } else {
            user_id = user.user_id;
        }
        const form = new FormData();
        form.append("date", date);
        form.append("price", price);
        form.append("concept", concept);
        form.append("box_office", user_id); // <-- Aquí se usa el usuario correcto
        form.append("partner_id", partner_id);
        form.append("driver_id", driver_id);
        form.append("unit_id", unit_id);
        form.append("gasoline", gasoline);
        form.append("meal", meal);
        form.append("salary", salary);
        form.append("spare_parts", spare_parts);
        form.append("negatives", negatives);
        form.append("personal", personal);
        form.append("permissions_documents", permissions_documents);
        form.append("schedule_id", schedule_id);
        form.append("running_date", running_date);
        form.append("mileage", mileage);
        form.append("stand", stand);
        form.append("administrative", administrative);
        if (bill_id === 0) {
            await axios
                .post(ENDPOINT + "save-bill", form)
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        } else {
            setLoading(true);
            await axios
                .put(ENDPOINT + "update-bill/" + bill_id, {
                    date: date,
                    price: price,
                    concept: concept,
                    partner_id: partner_id,
                    driver_id: driver_id,
                    unit_id: unit_id,
                    gasoline: gasoline,
                    meal: meal,
                    salary: salary,
                    spare_parts: spare_parts,
                    negatives: negatives,
                    personal: personal,
                    permissions_documents: permissions_documents,
                    schedule_id: schedule_id,
                    running_date: running_date,
                    mileage: mileage,
                    stand: stand,
                    administrative: administrative,
                })
                .then((response) => {
                    getAll();
                    clearField();
                    setLoading(false);
                    $("#closemodal").trigger("click");
                    Swal.fire({
                        icon: "success",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    setLoading(true);
                    Swal.fire({
                        icon: "error",
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                        showClass: { popup: "animate__animated animate__fadeInDown" },
                        hideClass: { popup: "animate__animated animate__fadeOutUp" },
                    });
                });
        }
    };

    const clearField = () => {
        setBillId(0);
        setDate(new Date());
        setPrice(0);
        setConcept('');
        setPartnerId(0);
        setDriverId(0);
        setUnitId(0);
        setGasoline(0);
        setMeal(0);
        setSalary(0);
        setSpareParts(0);
        setNegatives(0);
        setPersonal(0);
        setPermissionsDocuments(0);
        setScheduleId(0);
        setRunningDate('');
        setMileage(0);
        setStand(0);
        setAdministrative(0);
        setTitle("Agregar Gasto por Unidad");
        // Remover y volver a agregar la clase select2
        $('#partner_id').removeClass('select2');
        $('#driver_id').removeClass('select2');
        $('#unit_id').removeClass('select2');
        // Resetear los valores de los select
        $('#partner_id').val(0).trigger('change');
        $('#driver_id').val(0).trigger('change');
        $('#unit_id').val(0).trigger('change');
        setTimeout(() => {
            $('#partner_id').addClass('select2');
            $('#driver_id').addClass('select2');
            $('#unit_id').addClass('select2');
            initializeSelect2();
        }, 100);
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-bill-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleDetail = async (id) => {
        setLoading(true);
        $('#partner_id').removeClass('select2');
        $('#driver_id').removeClass('select2');
        $('#unit_id').removeClass('select2');
        await axios
            .get(ENDPOINT + "get-bill/" + id)
            .then((response) => {
                setLoading(false);
                setBillId(response.data.data.bill_id);
                setDate(response.data.data.date);
                setPrice(response.data.data.price);
                setConcept(response.data.data.concept); 
                setPartnerId(response.data.data.partner_id);
                setDriverId(response.data.data.driver_id);
                setUnitId(response.data.data.unit_id);
                setGasoline(response.data.data.gasoline);
                setMeal(response.data.data.meal);
                setSalary(response.data.data.salary);
                setSpareParts(response.data.data.spare_parts);
                setNegatives(response.data.data.negatives);
                setPersonal(response.data.data.personal);
                setPermissionsDocuments(response.data.data.permissions_documents);
                setScheduleId(response.data.data.schedule_id);
                setRunningDate(response.data.data.running_date);
                setMileage(response.data.data.mileage);
                setStand(response.data.data.stand);
                setAdministrative(response.data.data.administrative ? response.data.data.administrative : 0);
                setTitle("Editar Gasto por Unidad");
                setTimeout(() => {
                    $('#partner_id').addClass('select2');
                    $('#driver_id').addClass('select2');
                    $('#unit_id').addClass('select2');
                    initializeSelect2();
                }, 100);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleEdit = async (id) => {
        setLoading(true);
        $('#partner_id').removeClass('select2');
        $('#driver_id').removeClass('select2');
        $('#unit_id').removeClass('select2');
        await axios
            .get(ENDPOINT + "get-bill/" + id)
            .then((response) => {
                setLoading(false);
                setBillId(response.data.data.bill_id);
                setDate(response.data.data.date);
                setPrice(response.data.data.price);
                setConcept(response.data.data.concept); 
                setPartnerId(response.data.data.partner_id);
                setDriverId(response.data.data.driver_id);
                setUnitId(response.data.data.unit_id);
                setGasoline(response.data.data.gasoline);
                setMeal(response.data.data.meal);
                setSalary(response.data.data.salary);
                setSpareParts(response.data.data.spare_parts);
                setNegatives(response.data.data.negatives);
                setPersonal(response.data.data.personal);
                setPermissionsDocuments(response.data.data.permissions_documents);
                setScheduleId(response.data.data.schedule_id);
                setRunningDate(response.data.data.running_date);
                setMileage(response.data.data.mileage);
                setStand(response.data.data.stand);
                setAdministrative(response.data.data.administrative ? response.data.data.administrative : 0);
                setTitle("Editar Gasto por Unidad");
                setTimeout(() => {
                    $('#partner_id').addClass('select2');
                    $('#driver_id').addClass('select2');
                    $('#unit_id').addClass('select2');
                    initializeSelect2();
                }, 100);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-bill/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        setLoading(true);
        const form = new FormData();
        form.append("status_filter", status_filter);
        form.append("driver_filter", driver_filter);
        form.append("partner_filter", partner_filter);
        form.append("unit_filter", unit_filter);
        const response = await axios.post(ENDPOINT + 'print-pdf-bills', form, { responseType: "blob" });
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        setLoading(false);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                {bill_id === 0 ? <i className="fas fa-plus-circle me-2"></i> : <i className="fas fa-edit me-2"></i>}
                                {title}
                            </h4>
                            <button onClick={clearField} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="bills-form-header">
                                    <h3 className="bills-form-title">Información del Gasto</h3>
                                    <p className="bills-form-subtitle">Complete los datos del gasto para la unidad seleccionada</p>
                                </div>
                                {JSON.parse(localStorage.getItem("dataUser"))?.user_id === 13 && (
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <label htmlFor="userSelect" className="form-label">
                                                Seleccionar Usuario:
                                            </label>
                                            <select
                                                id="userSelect"
                                                className="form-select form-control-sm"
                                                value={selectedUserId}
                                                onChange={(e) => setSelectedUserId(Number.parseInt(e.target.value))}

                                            >
                                                <option value="">Seleccione un usuario</option>
                                                {users.map((user) => (
                                                    <option key={user.user_id} value={user.user_id}>
                                                        {user.name} {user.last_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="date" className="col-form-label col-form-label-sm">
                                                Fecha <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm`}
                                                id="date"
                                                name="date"
                                                value={date}
                                                onChange={(e) => setDate(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Fecha en que se realizó el gasto</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="running_date" className="col-form-label col-form-label-sm">
                                                Fecha de Recorrido <span className="bills-required"></span>
                                            </label> 
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm`}
                                                id="running_date"
                                                name="running_date"
                                                value={running_date}
                                                onChange={(e) => setRunningDate(e.target.value)}
                                            />
                                            <small className="bills-field-hint">Fecha en que se realizó el recorrido</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="concept" className="col-form-label col-form-label-sm">
                                                Concepto <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese el concepto"
                                                id="concept"
                                                name="concept"
                                                value={concept}
                                                onChange={(e) => setConcept(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Descripción del gasto</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="partner_id" className="col-form-label col-form-label-sm">
                                                Socio <span className="bills-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="partner_id"
                                                name="partner_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {partners.map((item, index) => (
                                                    <option
                                                        selected={item.value === partner_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="bills-field-hint">Seleccione el socio responsable</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="driver_id" className="col-form-label col-form-label-sm">
                                                Conductor <span className="bills-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="driver_id"
                                                name="driver_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {drivers.map((item, index) => (
                                                    <option
                                                        selected={item.value === driver_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="bills-field-hint">Seleccione el conductor responsable</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="unit_id" className="col-form-label col-form-label-sm">
                                                Unidad <span className="bills-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="unit_id"
                                                name="unit_id"
                                                required
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {units.map((item, index) => (
                                                    <option
                                                        selected={item.value === unit_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="bills-field-hint">Seleccione la unidad correspondiente</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="gasoline" className="col-form-label col-form-label-sm">
                                                Gasolina <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese el monto"
                                                id="gasoline"
                                                name="gasoline"
                                                value={gasoline}
                                                onChange={(e) => setGasoline(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Monto gastado en gasolina</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="meal" className="col-form-label col-form-label-sm">
                                                Comida <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="meal"
                                                name="meal"
                                                value={meal}
                                                onChange={(e) => setMeal(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Monto gastado en comida</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="salary" className="col-form-label col-form-label-sm">
                                                Salario <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="salary"
                                                name="salary"
                                                value={salary}
                                                onChange={(e) => setSalary(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Monto gastado en salario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="spare_parts" className="col-form-label col-form-label-sm">
                                                Refracciones y Taller <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="spare_parts"
                                                name="spare_parts"
                                                value={spare_parts}
                                                onChange={(e) => setSpareParts(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Monto gastado en refracciones y taller</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="negatives" className="col-form-label col-form-label-sm">
                                                Negativos <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="negatives"
                                                name="negatives"
                                                value={negatives}
                                                onChange={(e) => setNegatives(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Monto gastado en negativos</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="personal" className="col-form-label col-form-label-sm">
                                                Personales <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="personal"
                                                name="personal"
                                                value={personal}
                                                onChange={(e) => setPersonal(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Monto gastado en personales</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="permissions_documents" className="col-form-label col-form-label-sm">
                                                Documentos y Permisos <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="permissions_documents"
                                                name="permissions_documents"
                                                value={permissions_documents}
                                                onChange={(e) => setPermissionsDocuments(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Monto gastado en documentos y permisos</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="mileage" className="col-form-label col-form-label-sm">
                                                Kilometraje <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese kilometraje"
                                                id="mileage"
                                                name="mileage"
                                                value={mileage}
                                                onChange={(e) => setMileage(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Kilometraje del recorrido</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="stand" className="col-form-label col-form-label-sm">
                                                Caseta <span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese caseta"
                                                id="stand"
                                                name="stand"
                                                value={stand}
                                                onChange={(e) => setStand(e.target.value)}
                                                required
                                            />
                                            <small className="bills-field-hint">Caseta</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="price" className="col-form-label col-form-label-sm">
                                                Precio Total<span className="bills-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                id="price"
                                                name="price"
                                                value={price}
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto del gasto total (calculado automáticamente)</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">Administrativo</label>
                                            <div>
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    onColor="#0d6efd"
                                                    checked={administrative === 1}
                                                    onChange={(checked) => setAdministrative(checked ? 1 : 0)}
                                                />
                                                <small className="bills-field-hint d-block">Si está activo, no se descontará en corte/ganancias</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer bills-form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {bill_id === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    onClick={clearField}
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modal-default-view" aria-labelledby="modal-default" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">
                                <i className="fas fa-eye me-2"></i> Detalle del Gasto por Unidad
                            </h4>
                            <button onClick={clearField} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="bills-form-header">
                                    <h3 className="bills-form-title">Información del Gasto</h3>
                                    <p className="bills-form-subtitle">Visualización de los datos del gasto para la unidad seleccionada</p>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="date" className="col-form-label col-form-label-sm">
                                                Fecha
                                            </label>
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm`}
                                                id="date"
                                                name="date"
                                                value={date}
                                                onChange={(e) => setDate(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Fecha en que se realizó el gasto</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-9">
                                        <div className="form-group">
                                            <label htmlFor="concept" className="col-form-label col-form-label-sm">
                                                Concepto
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese el concepto"
                                                id="concept"
                                                name="concept"
                                                value={concept}
                                                onChange={(e) => setConcept(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Descripción del gasto</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="partner_id" className="col-form-label col-form-label-sm">
                                                Socio
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="partner_id"
                                                name="partner_id"
                                                required
                                                readOnly
                                                disabled={true}
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {partners.map((item, index) => (
                                                    <option
                                                        selected={item.value === partner_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="bills-field-hint">Socio responsable</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="driver_id" className="col-form-label col-form-label-sm">
                                                Conductor
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="driver_id"
                                                name="driver_id"
                                                required
                                                readOnly
                                                disabled={true}
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {drivers.map((item, index) => (
                                                    <option
                                                        selected={item.value === driver_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="bills-field-hint">Conductor responsable</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="unit_id" className="col-form-label col-form-label-sm">
                                                Unidad
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                id="unit_id"
                                                name="unit_id"
                                                required
                                                readOnly
                                                disabled={true}
                                            >
                                                <option selected value="0">Seleccione</option>
                                                {units.map((item, index) => (
                                                    <option
                                                        selected={item.value === unit_id}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="bills-field-hint">Unidad correspondiente</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="gasoline" className="col-form-label col-form-label-sm">
                                                Gasolina
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese el monto"
                                                id="gasoline"
                                                name="gasoline"
                                                value={gasoline}
                                                onChange={(e) => setGasoline(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto gastado en gasolina</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="meal" className="col-form-label col-form-label-sm">
                                                Comida
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="meal"
                                                name="meal"
                                                value={meal}
                                                onChange={(e) => setMeal(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto gastado en comida</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="salary" className="col-form-label col-form-label-sm">
                                                Salario
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="salary"
                                                name="salary"
                                                value={salary}
                                                onChange={(e) => setSalary(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto gastado en salario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="spare_parts" className="col-form-label col-form-label-sm">
                                                Refracciones y Taller
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="spare_parts"
                                                name="spare_parts"
                                                value={spare_parts}
                                                onChange={(e) => setSpareParts(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto gastado en refracciones y taller</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="negatives" className="col-form-label col-form-label-sm">
                                                Negativos
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="negatives"
                                                name="negatives"
                                                value={negatives}
                                                onChange={(e) => setNegatives(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto gastado en negativos</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="personal" className="col-form-label col-form-label-sm">
                                                Personales
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="personal"
                                                name="personal"
                                                value={personal}
                                                onChange={(e) => setPersonal(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto gastado en personales</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="permissions_documents" className="col-form-label col-form-label-sm">
                                                Documentos y Permisos
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese monto"
                                                id="permissions_documents"
                                                name="permissions_documents"
                                                value={permissions_documents}
                                                onChange={(e) => setPermissionsDocuments(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto gastado en documentos y permisos</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="running_date" className="col-form-label col-form-label-sm">
                                                Fecha de Recorrido
                                            </label> 
                                            <input
                                                type="date"
                                                className={`form-control form-control-sm`}
                                                id="running_date"
                                                name="running_date"
                                                value={running_date}
                                                onChange={(e) => setRunningDate(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Fecha en que se realizó el recorrido</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="mileage" className="col-form-label col-form-label-sm">
                                                Kilometraje
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese kilometraje"
                                                id="mileage"
                                                name="mileage"
                                                value={mileage}
                                                onChange={(e) => setMileage(e.target.value)}
                                                required
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Kilometraje del recorrido</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="price" className="col-form-label col-form-label-sm">
                                                Precio Total 
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm`}
                                                id="price"
                                                name="price"
                                                value={price}
                                                readOnly
                                            />
                                            <small className="bills-field-hint">Monto del gasto total</small>
                                        </div>
                                    </div>
                                            <div className="col-12 col-sm-3">
                                                <div className="form-group">
                                                    <label className="col-form-label col-form-label-sm">Administrativo</label>
                                                    <div>
                                                        <Switch
                                                            checkedIcon={false}
                                                            uncheckedIcon={false}
                                                            checked={administrative === 1}
                                                            onChange={() => {}}
                                                            disabled={true}
                                                        />
                                                        <small className="bills-field-hint d-block">Registro marcado como administrativo</small>
                                                    </div>
                                                </div>
                                            </div>
                                </div>
                            </div>
                            <div className="modal-footer bills-form-actions">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-bs-dismiss="modal">
                                    <i className="fa-solid fa-ban me-1"></i> Cerrar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Gastos por Unidad" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-currency-dollar me-1"></i> Listado de Gastos por Unidad
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={handleNew}
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </button>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="bills-indications row mb-4">
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="date_filter" className="col-form-label col-form-label-sm">
                                        Fecha
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        id="date_filter"
                                        name="date_filter"
                                        value={date_filter}
                                        onChange={(e) => setDateFilter(e.target.value)}
                                    />
                                    <small className="bills-field-hint">Filtra por fecha</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="select_status" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                    >
                                        {selectStatus.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="bills-field-hint">Filtra por estado actual</small>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="driver_filter" className="col-form-label col-form-label-sm">
                                        Conductor
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="driver_filter"
                                        name="driver_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {drivers.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="bills-field-hint">Filtra por conductor</small>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="partner_filter" className="col-form-label col-form-label-sm">
                                        Socio
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="partner_filter"
                                        name="partner_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {partners.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="bills-field-hint">Filtra por socio</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="unit_filter" className="col-form-label col-form-label-sm">
                                        Unidad
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="unit_filter"
                                        name="unit_filter"
                                    >
                                        <option selected value="0">Seleccione</option>
                                        {units.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="bills-field-hint">Filtra por unidad</small>
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-6 mb-3 text-end">
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                <button
                                    onClick={() => handlePrint()}
                                    className="btn btn-danger btn-sm me-1">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>
                            </div>
                            <div className="d-flex justify-content-center items-align-center">
                                <div className="col-md-6 col-sm-6 col-xs-12 mt-3">
                                    <div className="form-group">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr className="text-center">
                                                    <td className="indications-table" width="30%" >Total</td>
                                                    <td className="indications-table" width="30%" >Activos</td>
                                                    <td className="indications-table" width="30%" >Inactivos</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td id="TuserT">{active + inactive}</td>
                                                    <td id="TuserA">{active}</td>
                                                    <td id="TuserI">{inactive}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">Fecha</th>
                                    <th className="text-center">Usuario</th>
                                    <th className="text-center">Concepto</th>
                                    <th className="text-center">Socio</th>
                                    <th className="text-center">Conductor</th>
                                    <th className="text-center">Unidad</th>
                                    <th className="text-center">Total</th>
                                    <th className="text-center">Estado</th>
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bills.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd># {item.bill_id}</kbd>
                                        </td>
                                        <td>
                                            {formatDate(item.date)}
                                        </td>
                                        <td>
                                            {item.user.name} {item.user.last_name}
                                        </td>
                                        <td>
                                            {item.concept}
                                            {item.administrative == 1 && (
                                                <span className="badge bg-secondary ms-2">Administrativo</span>
                                            )}
                                        </td>
                                        <td>
                                        {item.partner.name_partner}                                            
                                        </td>
                                        <td>
                                        {item.driver.name + ' ' + item.driver.last_name}                                            
                                        </td>
                                        <td>
                                            {item.unit.name}
                                        </td>
                                        <td className="text-center">
                                            {item.price}
                                        </td>
                                        <td className="text-center">
                                            <div data-bs-toggle="tooltip" data-bs-placement="top" title="Estado">
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.bill_id)}
                                                />
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <div>
                                                <span
                                                    title="Ver registro"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default-view"
                                                        className="btn-sm btn btn-primary me-1"
                                                        onClick={() => handleDetail(item.bill_id)}>
                                                        <i className="fas fa-eye"></i>
                                                    </button>
                                                </span>
                                                <span
                                                    title="Editar registro"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        className="btn-sm btn btn-warning me-1"
                                                        onClick={() => handleEdit(item.bill_id)}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </span>
                                                <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Eliminar registro"
                                                    className="btn-sm btn btn-danger me-1"
                                                    onClick={() => handleDelete(item.bill_id, item.concept)}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Bills;